
const docsAIContent = {
  overview: {
    title: "inFlow DocsAI",
    description:
      "inFlow DocsAI deploys AI agents that automate document handling across summarization, extraction, transcription, and intelligent search. These agents work across formats and languages to deliver structured, accurate outputs, helping teams reduce manual effort, accelerate workflows, and act on information faster. ",
    imageURL: "/images/products/DocsAI-3D-Studio-Banner.png",
    screenURL: "/images/products/DocsAI-3D-Studio-Banner.png",
  },

  demos: [
    {
      title: "Extraction",
      path: "/demo/extraction",
      image: "/images/products/DocsAI-Extraction.png",
      description: [
        "Extract structured data from logistics documents like invoices and bills of lading — directly into Excel. No templates required, no manual entry.",
      ],
      button: "Extraction",
    },
    // {
    //   title: "Summarization",
    //   path: "/demo/summarization",
    //   image: "/images/products/DocsAI-Summarization.png",
    //   description: [
    //     "Instantly summarize lengthy documents such as legal cases or reports. Surface key insights in seconds to support faster decisions.",
    //   ],
    //   button: "Summarization",
    // },
    {
      title: "Transcription",
      path: "/demo/transcription",
      image: "/images/products/DocsAI-Transcription.png",
      description: [
        "Transcribe doctor dictations or recorded consultations into structured text. Automatically generate reports, referral letters, and clinical summaries.",
      ],

      button: "Transcription",
    },
    {
      title: "Claims Triage",
      path: "/demo/claims-triage",
      image: "/images/products/DocsAI-Claims-Triage.png",
      description: [
        "Analyze health insurance claims across multiple documents and determine eligibility instantly. Automate claim validation without manual review.",
      ],
      button: "Claims Triage",
    },
    {
      title: "Banking Assistant",
      path: "/demo/banking-assistant",
      image: "/images/products/DocsAI-BankingAssistant.png",
      description: [
        "AI assistant that analyzes financial documents such as bank statements and credit card bills to answer user queries, while also handling everyday banking-related questions.",
      ],
      button: "Banking Assistant",
    },
  ],

  pricing: {
    plans: [
      {
        id: "lite",
        name: "LITE",
        price: 399,
        period: "month",
        conversations: "1500 pages / minutes",
        popular: false,
        features: [
          { label: "Workflows", value: "Unlimited" },
          { label: "Data Validation", value: "Simple" },
          { label: "Models", value: "Basic" },
          { label: "Storage", value: "100 MB" },
          { label: "AI Credits", value: "7500" },
          { label: "Manual Upload", value: true },
          { label: "API", value: true },
          { label: "Storage (Cloud)", value: true },
          { label: "Email", value: false },
          { label: "Custom Integrations", value: false },
          { label: "External App Integration", value: false },
          { label: "Chained Workflow Output", value: false }
        ]
      },
      {
        id: "professional",
        name: "PROFESSIONAL",
        price: 599,
        period: "month",
        conversations: "3000 pages / minutes",
        popular: true,
        features: [
          { label: "Workflows", value: "Unlimited" },
          { label: "Data Validation", value: "Agentic" },
          { label: "Models", value: "Premium" },
          { label: "Storage", value: "500 MB" },
          { label: "AI Credits", value: "15000" },
          { label: "Manual Upload", value: true },
          { label: "API", value: true },
          { label: "Storage (Cloud)", value: true },
          { label: "Email", value: true },
          { label: "Custom Integrations", value: false },
          { label: "External App Integration", value: true },
          { label: "Chained Workflow Output", value: false }
        ]
      },
      {
        id: "enterprise",
        name: "ENTERPRISE",
        price: 899,
        period: "month",
        conversations: "6000 pages / minutes",
        popular: false,
        features: [
          { label: "Workflows", value: "Unlimited" },
          { label: "Data Validation", value: "Agentic" },
          { label: "Models", value: "Premium" },
          { label: "Storage", value: "2 GB" },
          { label: "AI Credits", value: "30000" },
          { label: "Manual Upload", value: true },
          { label: "API", value: true },
          { label: "Storage (Cloud)", value: true },
          { label: "Email", value: true },
          { label: "Custom Integrations", value: true },
          { label: "External App Integration", value: true },
          { label: "Chained Workflow Output", value: true }
        ]
      }
    ]
  },
  usecase: [
    {
      industry: "Banking & Financial Services",
      points: [
        "Automating loan application review by extracting and verifying data from ID proofs, bank statements, and salary slips",
        "Streamlining KYC and onboarding processes through extraction of customer details from forms and documents",
        "Processing transaction records, account statements, and compliance reports for audits and reconciliation",
        "Supporting regulatory documentation and reporting with structured and validated output",
      ],
    },
    {
      industry: "Insurance",
      points: [
        "Extracting claim-related data from incident reports, forms, and supporting documents",
        "Automating policy generation and renewal workflows using form understanding and prefilled templates",
        "Processing underwriting documents such as health declarations and risk assessments",
        "Enabling faster turnaround for agent-submitted documents through mobile scanning and classification",
      ],
    },
    {
      industry: "Logistics & Supply Chain",
      points: [
        "Automating bill of lading, delivery notes, and shipment confirmation processing",
        "Extracting data from customs documents and certificates of origin for cross-border trade",
        "Digitizing vendor contracts and supplier agreements for tracking and compliance",
        "Processing inbound and outbound documentation at distribution centers for inventory reconciliation",
      ],
    },
    {
      industry: "Healthcare",
      points: [
        "Extracting clinical information from scanned prescriptions, discharge summaries, and referral letters",
        "Processing insurance claims and medical billing documents",
        "Digitizing handwritten case notes and converting them into structured data for patient records",
        "Automating the creation of structured documents from dictated or transcribed reports",
      ],
    },
    {
      industry: "Government & Public Sector",
      points: [
        "Digitizing citizen applications, affidavits, and supporting documents for faster approvals",
        "Extracting structured data from legal and administrative documents to support public service delivery",
        "Supporting large-scale document digitization initiatives with classification and metadata tagging",
        "Automating form validation and routing across departments and jurisdictions",
      ],
    },
    {
      industry: "Legal & Professional Services",
      points: [
        "Extracting clauses, dates, parties, and obligations from contracts and agreements",
        "Processing court filings, case summaries, and legal notices with high accuracy",
        "Automating client onboarding documentation and engagement letters",
        "Tagging and organizing historical legal documents for fast retrieval and reference",
      ],
    },
  ],

  customerstory: {
    stories: [
      {
        text: "Leading Malaysian Bank Enhances Compliance & Efficiency with AI-Powered Document Intelligence",
        url: "https://inextlabs.ai/resources/bank-rakyat-casestudy",
      },
    ],
  },
  resources: {
    diagrams: [
      {
        name: "Financial Statement Extraction Demo",
        type: "video",
        tag: "VIDEO",
        image: "DocsAI-FinancialExtractor.mp4",
        duration: "7 min",
        size: "Video · 37.3 MB",
        desc: "Automated extraction and verification of financial metrics and balance sheets.",
        isHero: true,
      },
      {
        name: "Extraction Demo",
        type: "video",
        tag: "VIDEO",
        image: "DocsAI Promotional Video.mp4",
        duration: "10 min",
        size: "Video · 46.3 MB",
        desc: "Watch how DocsAI extracts structured tables and text from complex multi-page documents.",
      },
      {
        name: "DocsAI Promotional Video",
        type: "video",
        tag: "VIDEO",
        image: "DocsAI Promotional Video.mp4",
        duration: "5 min",
        size: "Video · 46.3 MB",
        desc: "Discover next-generation AI document processing capabilities for enterprise workflows.",
      },
      {
        name: "DocsAI Standard Extraction Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/Inflow-assistant.svg",
        size: "SVG · 185 KB",
        desc: "Architectural overview of OCR, entity recognition, and structured output pipeline.",
      },
      {
        name: "DocsAI Standard Extraction BOM",
        type: "doc",
        tag: "EXCEL",
        image: "documents/DocsAI-StandardExtraction-BOM.xlsx",
        size: "XLSX · 7.1 KB",
        desc: "Sample bill of materials and feature specification matrix for enterprise deployments.",
      },
      {
        name: "DocsAI proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowDocsAI-Proposal.docx",
        size: "DOCX · 6.2 MB",
        desc: "Comprehensive commercial proposal, SLA tiers, and deployment pricing roadmap.",
      },
    ],
  },
};

export default docsAIContent;


